module.exports = __webpack_public_path__ + "img/icon_rol_over.aafefe72.svg";